module.exports = __webpack_public_path__ + "img/bug.307a92e7.png";